/**
 * RUM errors that are noise, not actionable bugs. Used by DatadogInit
 * `beforeSend` so they never leave the browser.
 *
 * - Cross-origin "Script error." has no stack and cannot be attributed.
 * - next-sanity `<SanityLive>` logs reconnects with console.error; live stays
 *   mounted on purpose, so this is expected EventSource drop noise.
 * - ResizeObserver loop messages are a known browser quirk, not app faults.
 * - Minified React #418 is a hydration text/HTML mismatch. On Discovery it is
 *   intermittent, Chromium-only, and clustered in non-English locales — Chrome
 *   auto-translate / extensions mutating the DOM before hydrate, not a
 *   first-party SSR bug (WEL-1807).
 */
const IGNORED_ERROR_SUBSTRINGS = [
	"Script error.",
	"<SanityLive> is attempting to reconnect",
	"ResizeObserver loop",
	"Minified React error #418",
] as const;

export function shouldIgnoreRumError(message: string): boolean {
	return IGNORED_ERROR_SUBSTRINGS.some((substring) =>
		message.includes(substring)
	);
}
